import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSend } = FiIcons;

const ContactForm = () => (
  <div className="bg-white p-12 rounded-[50px] border border-brand-dark shadow-sm">
    <div className="max-w-xl mx-auto text-center mb-12">
      <h3 className="text-3xl font-serif text-accent-navy mb-4">Get in Touch</h3>
      <p className="text-text-muted font-light">Our compassionate team is here to support you 24/7.</p>
    </div>
    <form className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
      <input type="text" placeholder="Full Name" className="p-4 rounded-xl border border-brand-dark outline-none focus:ring-2 focus:ring-accent-gold/20" />
      <input type="email" placeholder="Email Address" className="p-4 rounded-xl border border-brand-dark outline-none focus:ring-2 focus:ring-accent-gold/20" />
      <div className="md:col-span-2">
        <textarea placeholder="How can we help you today?" rows="4" className="w-full p-4 rounded-xl border border-brand-dark outline-none focus:ring-2 focus:ring-accent-gold/20" />
      </div>
      <button className="md:col-span-2 btn-primary py-4 rounded-xl flex items-center justify-center gap-2">
        Send Message <SafeIcon icon={FiSend} />
      </button>
    </form>
  </div>
);

export default ContactForm;